var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1417 5.57031H10.4275V1.85603C10.4275 1.69888 10.2989 1.57031 10.1417 1.57031H1.85603C1.69888 1.57031 1.57031 1.69888 1.57031 1.85603V10.1417C1.57031 10.2989 1.69888 10.4275 1.85603 10.4275H5.57031V14.1417C5.57031 14.2989 5.69888 14.4275 5.85603 14.4275H14.1417C14.2989 14.4275 14.4275 14.2989 14.4275 14.1417V5.85603C14.4275 5.69888 14.2989 5.57031 14.1417 5.57031ZM5.57031 5.85603V9.21317H2.7846V2.7846H9.21317V5.57031H5.85603C5.69888 5.57031 5.57031 5.69888 5.57031 5.85603ZM9.21317 6.7846V9.21317H6.7846V6.7846H9.21317ZM13.2132 13.2132H6.7846V10.4275H10.1417C10.2989 10.4275 10.4275 10.2989 10.4275 10.1417V6.7846H13.2132V13.2132Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompare);
export default __webpack_public_path__ + "static/media/compare.13b099e5e1e7b72fddb182f1f4ed39e5.svg";
export { ForwardRef as ReactComponent };